import React, { useMemo } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function ContractorProjectsList({ contractorId, projects, loading, error }) {
  const sortedProjects = useMemo(() => {
    if (!projects) return [];
    return [...projects].sort((a, b) => (a.fullEA || "").localeCompare(b.fullEA || ""));
  }, [projects]);

  if (loading) {
    return (
      <div className="text-muted py-2">
        <FontAwesomeIcon icon="spinner" className="fa-fw mr-2" spin />
        Loading projects...
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-danger py-1">
        <FontAwesomeIcon icon="exclamation-circle" className="fa-fw mr-1" />
        Failed to load projects.
      </div>
    );
  }

  if (!projects || projects.length === 0) {
    return <div className="text-muted py-1">No projects for this contractor</div>;
  }

  return (
    <div className="contractor-projects-list">
      <div className="d-flex flex-row bg-lightgray py-1 px-2 font-weight-bold small">
        <div style={{ width: "70%" }}>EA</div>
        <div style={{ width: "30%" }}>Role</div>
      </div>
      {sortedProjects.map((project, index) => (
        <div
          key={`ctr_${contractorId}_proj_${index}`}
          className="d-flex flex-row py-1 px-2 border-bottom small"
        >
          <div style={{ width: "70%" }}>{project.fullEA || "-"}</div>
          <div style={{ width: "30%" }}>
            <span
              className={project.isPrime ? "text-primary font-weight-bold" : ""}
            >
              {project.isPrime ? "Prime" : "Sub"}
            </span>
          </div>
        </div>
      ))}
    </div>
  );
}
